// extracted by mini-css-extract-plugin
export var errorsContainer = "_ui-1";
export var link = "_ui-0";